// @mui
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
// utils
import { fToNow } from 'src/utils/format-time';
import { getFieldBasedOnLang } from 'src/utils/helper';

// ----------------------------------------------------------------------

type NotificationItemProps = {
  notification: {
    id: string;
    type?: string;
    message?: string;
    content?: any;
    createdAt: Date;
  };
  onCloseDrawer: VoidFunction;
};

export default function NotificationItem({ notification, onCloseDrawer }: NotificationItemProps) {
  const navigate = useNavigate();

  const renderAvatar = (
    <ListItemAvatar>
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          bgcolor: 'background.neutral',
        }}
      >
        <Box
          component="img"
          src={`/assets/icons/notification/ic_notification.svg`}
          sx={{ width: 24, height: 24 }}
        />
      </Stack>
    </ListItemAvatar>
  );

  const renderText = (
    <ListItemText
      disableTypography
      primary={getFieldBasedOnLang(notification?.message)}
      secondary={
        <Stack
          direction="row"
          alignItems="center"
          sx={{ typography: 'caption', color: 'text.disabled' }}
          divider={
            <Box
              sx={{
                width: 2,
                height: 2,
                bgcolor: 'currentColor',
                mx: 0.5,
                borderRadius: '50%',
              }}
            />
          }
        >
          <Stack>
            <Stack>{getFieldBasedOnLang(notification?.content)}</Stack>
            <Stack>{fToNow(notification?.createdAt)}</Stack>
          </Stack>
        </Stack>
      }
    />
  );

  return (
    <ListItemButton
      disableRipple
      sx={{
        p: 2.5,
        alignItems: 'flex-start',
        borderBottom: (theme) => `dashed 1px ${theme.palette.divider}`,
      }}
      onClick={() => {
        if (notification?.type == 'ticket')
          navigate(paths.dashboard.helpCenter.ticketInfo(notification?.content?.id));

        if (notification?.type == 'video_report')
          navigate(paths.dashboard.helpCenter.reportedVideoInfo(notification?.content?.id));

        if (notification?.type == 'app_suggested')
          navigate(paths.dashboard.parentSuggestions.suggestionDetails(notification?.content?.id));
      }}
    >
      {renderAvatar}

      <Stack sx={{ flexGrow: 1 }}>{renderText}</Stack>
    </ListItemButton>
  );
}

// ----------------------------------------------------------------------

function reader(data: string) {
  return (
    <Box
      dangerouslySetInnerHTML={{ __html: data }}
      sx={{
        mb: 0.5,
        '& p': { typography: 'body2', m: 0 },
        '& a': { color: 'inherit', textDecoration: 'none' },
        '& strong': { typography: 'subtitle2' },
      }}
    />
  );
}
